import { Content, Footer, Header, Layout, ProcessHeader } from '@library/components'
import type { FC } from 'react'

import css from './Playground.css'

const projectId = ''

export const Playground: FC = () => {
  return (
    <Layout className={css.playground}>
      <ProcessHeader projectId={projectId} projectName="Test" processName="Процесс" />
      <Content />
      <Footer>
        <Header>
          <Header.RightBlock>
            <Footer.ExpandButton />
          </Header.RightBlock>
        </Header>
        <Footer.Body className={css.footer}>Body</Footer.Body>
      </Footer>
    </Layout>
  )
}
